const SELECTOR = {
    HTML: document.documentElement,
    TRIGGER: document.querySelector('[data-reserve-observer]'),
    BUTTON: document.querySelector('[data-reserve]'),
    SP_HEADER: document.querySelector('.sp-header'),
}

const CLASSES = {
    VISIBLE: 'is-visible',
    INVISIBLE: 'is-invisible',
}

export default class Reserve {
    constructor() {
        if (!SELECTOR.BUTTON || !SELECTOR.TRIGGER) return;
        SELECTOR.BUTTON.classList.add(CLASSES.VISIBLE);
        SELECTOR.BUTTON.classList.remove(CLASSES.INVISIBLE)
        if (location.pathname === "/" || location.pathname === "/index.php") {
            setTimeout(() => {
                SELECTOR.SP_HEADER.classList.remove(CLASSES.INVISIBLE)
            }, 2200)
        } else {
            setTimeout(() => {
                SELECTOR.SP_HEADER.classList.remove(CLASSES.INVISIBLE)
            }, 0)
        }
        // const observerReserve = new IntersectionObserver ((entries) => {
        //   for(const e of entries) {
        //     if (e.isIntersecting) {
        //       SELECTOR.BUTTON.classList.remove(CLASSES.VISIBLE);
        //     } else {
        //       SELECTOR.BUTTON.classList.add(CLASSES.VISIBLE);
        //     }
        //   }
        // });

        // observerReserve.observe(SELECTOR.TRIGGER);
    }
}